import React, {useContext} from "react";
import DataContext from "../DataContext";
import TreeNode from "./TreeNode";
import styles from "./Tree.module.scss";
import withBreadcrumbs from "react-router-breadcrumbs-hoc";

const TreeView = ({breadcrumbs}) => {
    const {data} = useContext(DataContext);

    return (
        <div className={`${styles.mainSidebarStyle} d-none`}>
            <div className={`${styles.sidebar}`} >
                <ul className={`${styles.sidebarTreeList}`}>
                    <p>Aktivni Dropdown</p>
                    {data?.map((i) => <TreeNode node={i} children={i.children} firstItem={true} breadcrumbs={breadcrumbs}/>)}
                </ul>
            </div>
        </div>

    )
};

export default  withBreadcrumbs()(TreeView);